import { useState, useEffect } from 'react'

async function fetchRelatedPuppies (data, dogId, setDogRelatedPuppies) {
  if (data) {
    const response = await fetch(`/api/related-puppies/${data?.dog?.breed?.id}`)
    const jsonResponse = await response.json()
    const _dogRelated = jsonResponse.relatedPuppies?.filter(
      (d) => d.profilePicture?.medium && d.id !== dogId
    )
    setDogRelatedPuppies(prevState => [...prevState, ..._dogRelated])
  }
}

function useFetchRelatedPuppies (data, dogId) {
  const [dogRelatedPuppies, setDogRelatedPuppies] = useState([])

  useEffect(() => {
    fetchRelatedPuppies(data, dogId, setDogRelatedPuppies)
  }, [data, dogId])

  return dogRelatedPuppies
}

export default useFetchRelatedPuppies
